export const BRANDS = {
  zillow: 'zillow',
  hotpads: 'hotpads',
  trulia: 'trulia',
};
